// extracted by mini-css-extract-plugin
export default {"root":"animatedWaitingIcon_root__6BKgg","loader":"animatedWaitingIcon_loader__E+66h","rotation":"animatedWaitingIcon_rotation__nQlgq"};